import { RouteScroller } from "@client/components/utils/RouteScroller";
import { RoundWizard } from "@client/components/wizard/RoundWizard";
import type { ReactNode } from "react";

/**
 * The empty-state welcome. It owns the route scroller, so anything a caller
 * wants above the welcome (Home's admin demo-round tool) goes through `before`
 * and scrolls with it — a wrapper around this component would leave the
 * scroller with no bounded height and the wizard clipped at the fold.
 */
export function Onboarding({
  isSfcAdmin,
  before,
}: {
  isSfcAdmin: boolean;
  before?: ReactNode;
}) {
  return (
    <RouteScroller>
      {before}
      <div className="mx-auto w-full max-w-3xl py-12 px-4 md:px-8 flex flex-col gap-8">
        <div className="text-center flex flex-col gap-2">
          <h1 className="text-3xl font-bold">Welcome to S-Process</h1>
          <p className="text-lg text-muted-foreground">
            {isSfcAdmin
              ? "Let's get you set up in just a few steps"
              : "You’re not part of a round yet. Ask a round admin for an invitation."}
          </p>
        </div>
        {isSfcAdmin && <RoundWizard isSfcAdmin={isSfcAdmin} />}
      </div>
    </RouteScroller>
  );
}
